export default __webpack_public_path__ + "static/media/P1j.6fbed414.jpg";